import type {
  AgentTraits,
  AnalyticsAdapter,
  AnalyticsConfig,
  AnalyticsPageViewProperties,
  AnalyticsTrackProperties,
} from './analyticsAdapter.ts'

/**
 * Silent adapter that does nothing - used when analytics is disabled.
 */
export class NoOpAnalyticsAdapter implements AnalyticsAdapter {
  initialize(_config: AnalyticsConfig): void {}
  identify(_agentId: string, _traits?: AgentTraits): void {}
  track(_eventName: string, _properties?: AnalyticsTrackProperties): void {}
  pageView(
    _screenName: string,
    _properties?: AnalyticsPageViewProperties,
  ): void {}
  reset(): void {}
}
